<template>
  <div class="receipt">
    <div class="content">
      <div class="header">
        <van-field v-model="orderNo" label="订单号" :readonly="true" />
      </div>
      <div class="main">
        <van-field v-model="test2" label="发票类型" :readonly="true" placeholder="电子发票" />
        <van-field label="开票状态" :readonly="true"  value="已开票" v-if="isHasRecord"/>
        <van-field v-model="test3" label="发票金额" :readonly="true" />
        <van-field v-model="test4" label="开票方式" :readonly="true" />
        <van-field label="发票抬头" :readonly="true"  value="单位" v-if="isHasRecord"/>
        <van-field name="radio" label="发票抬头" v-if="!isHasRecord">
          <template #input>
            <van-radio-group v-model="radioType" direction="horizontal">
              <van-radio name="personal">
                个人
                <template #icon="props">
                  <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
              </van-radio>
              <van-radio name="company">
                单位
                <template #icon="props">
                  <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <template v-if="radioType === 'personal'">
          <van-field v-model="time" label="申请时间" :readonly="true" v-if="isHasRecord"/>
          <van-field v-model="personalEmail" label="邮箱地址"  :readonly="isHasRecord" placeholder="（必填）" clearable/>
        </template>
        <template v-if="radioType === 'company'">
          <van-field v-model="test7" label="公司抬头"  :readonly="isHasRecord" placeholder="（必填）" clearable/>
          <van-field v-model="test8" label="纳税人识别号"  :readonly="isHasRecord" placeholder="（必填）" class="taxpayer-identification" clearable/>
          <van-field v-model="time"  label="申请时间" :readonly="true" v-if="isHasRecord"/>
          <van-field v-model="companyEmail" label="邮箱地址" :readonly="isHasRecord" placeholder="（必填）" clearable/>
        </template>

      </div>
      <div class="footer">
        <div class="title">温馨提示：</div>
        <div class="text">1、应国家税务局要求，若开具增值税普通发票，需要同时提供企业抬头及纳税人识别号，否则发票将无法用于企业报销； </div>
        <div class="text">2、企业能否报销请根据贵公司财务具体规定确认。</div>
      </div>
      <div class="action-wrapper" v-if="!isHasRecord">
        <invoice-button :disabled="false" text="提交申请" @handleButtonClick="handleApplyClick"></invoice-button>
      </div>
      <div class="action-wrapper" v-if="isHasRecord">
        <invoice-button :disabled="false" text="重开发票" @handleButtonClick="handleReinvoicingClick"></invoice-button>
      </div>
    </div>

    <van-action-sheet v-model="isActionSheetshow" title="确认邮箱地址">
      <div class="sheet-content">
        <div class="sheet-field">
          <van-field v-model="reinvoicingEmail" center clearable label="" placeholder="请输入邮箱地址"></van-field>
        </div>
        <div class="sheet-action">
           <invoice-button :disabled="false" text="提交申请" @handleButtonClick="handleReinvoicingApply"></invoice-button>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import invoiceButton from '@/components/invoiceButton'
import { isEmail, isTaxNumber} from '../../utils/validate'
import wx from 'weixin-js-sdk'
export default {
  name: 'Receipt',
  components:{
    invoiceButton
  },
  data: () => {
    return {
      orderNo: null,
      test2: '电子发票',
      test3: '￥18.8',
      test4: '商品明细',
      radioType: 'company',
      personalEmail: null,
      test7: null,
      test8: null,
      companyEmail: null,
      activeIcon: require('@/assets/invoice/active.png'),
      inactiveIcon: require('@/assets/invoice/inactive.png'),
      isActionSheetshow: false,
      reinvoicingEmail: null,
      isHasRecord: false,
      time: '2021-02-02 20:00'
    }
  },
  mounted(){
    this.orderNo = this.$route.query.orderNo;
    wx.ready(() => { 
       wx.hideOptionMenu()
    }); 
    if(!this.orderNo){
      return this.$toast({ message: '没有订单号'});
    }
    
  },
  methods:{
    handleApplyClick(){
      if(this.radioType === 'personal'){
        if(!this.personalEmail || !this.personalEmail.trim()){
          return  this.$toast({ message: '请填写邮箱地址'});
        }

        if(!isEmail(this.personalEmail)){
          return  this.$toast({ message: '请填写正确的邮箱地址'});
        } 
      }

      if(this.radioType === 'company'){
        if(!this.test7 || !this.test7.trim()){
          return  this.$toast({ message: '请填写公司抬头'});
        }

        if(!this.test8 || !this.test8.trim()){
          return  this.$toast({ message: '请填写纳税人识别号'});
        }

        if(!isTaxNumber(this.test8)){
          return  this.$toast({ message: '请填写正确的纳税人识别号'});
        } 

        if(!this.companyEmail || !this.companyEmail.trim()){
          return  this.$toast({ message: '请填写邮箱地址'});
        }

        if(!isEmail(this.companyEmail)){
          return  this.$toast({ message: '请填写正确的邮箱地址'});
        } 
      }

      console.log(this.personalEmail,'personal')
      console.log(this.test7,this.test8,this.companyEmail,'company')

      console.log('handleApplyClick')
    },
    handleReinvoicingClick(){
      this.isActionSheetshow = true
    },
    handleReinvoicingApply(){
      if(!this.reinvoicingEmail || !this.reinvoicingEmail.trim()){
        return  this.$toast({ message: '请填写邮箱地址'});
      }

      if(!isEmail(this.reinvoicingEmail)){
        return  this.$toast({ message: '请填写正确的邮箱地址'});
      } 
      this.isActionSheetshow = false
    }
  }
}
</script>

<style lang="scss">
.receipt{
  background: #F5F5F5;
  height: 100%;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  .van-cell{
    padding: 32px 28px;
    line-height: 44px;
    .van-field__label{
      width: 112px;
      color: #979797;
      margin-right: 32px;
    }
    &.taxpayer-identification{
      .van-field__label{
        width: 168px;
      }
    }
    .van-field__value{
      .van-field__control:disabled {
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 28px;
        color: #979797;;
        -webkit-text-fill-color: #979797
      }
    }
    &::after{
      border-bottom: none;
    }
    .van-radio{
      .van-radio__icon{
        .img-icon{
          width: 28px;
        }
      }
    }
  }

  .content{
    width: 100%;
    padding: 28px 40px;
    box-sizing: border-box;
    height: 100%;
    padding-bottom: 230px;
    overflow-y: auto;
    .header{
      margin-bottom: 28px;
      border-radius: 16px;
      overflow: hidden;
    }
    .main{
      margin-bottom: 28px;
      border-radius: 16px;
      overflow: hidden;
    }
    .footer{
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #979797;
      line-height: 36px;
      .title{
        margin-bottom: 8px;
      }
    }
  }

  .action-wrapper{
    background: white;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 20px 64px 40px 64px;
    box-shadow: 0px -2px 20px 0px rgba(17, 17, 17, 0.04);
    backdrop-filter: blur(0px);
  }

  *::-webkit-input-placeholder {
  font-family: 'PingFangSC-Regular', 'PingFang SC' !important;
  font-size: 28px;
  }
  *:-moz-placeholder {
    font-family: 'PingFangSC-Regular', 'PingFang SC' !important;
    font-size: 28px;
  }
  *::-moz-placeholder {
    font-family: 'PingFangSC-Regular', 'PingFang SC' !important;
    font-size: 28px;
  }
  *:-ms-input-placeholder {
    font-family: 'PingFangSC-Regular', 'PingFang SC' !important;
    font-size: 28px;
  }

  .sheet-content{
    border-top: 1px solid #EEEEEE;
    padding: 0 40px;
    .sheet-field{
      margin-bottom: 42px;
      border-bottom: 1px solid #EEEEEE;
    }
    .sheet-action{
      margin-bottom: 40px;
    }
  }

}


</style>
